import {
  collection,
  doc,
  query,
  where,
  orderBy,
  type Query,
  type DocumentReference,
  type CollectionReference
} from '../libs/firestore-wrapper';
import db_config from '../configs/db_config';
import { db } from '../libs/firebase';

function getAllOrders(): CollectionReference {
  return collection(db, db_config.DB_TABLE_ALL_ORDERS);
}

function getCurrentSettings(resId: string): DocumentReference {
  return doc(db, db_config.DB_TABLE_RESTAURANT_CONFIG, resId);
}

function getStadiumConfig(): CollectionReference {
  return collection(db, db_config.DB_STADIUM_MANAGE);
}

function getAllCatagories(resId: string): Query {
  return query(collection(db, db_config.DB_TABLE_ALL_CATEGORIES), where('restaurantId', '==', resId), orderBy('order'));
}

function getAllFoods(resId: string): Query {
  return query(collection(db, db_config.DB_TABLE_ALL_FOOD_DETAILS), where('restaurantId', '==', resId));
}

function getFoodDetails(foodId: string): DocumentReference {
  return doc(db, db_config.DB_TABLE_ALL_FOOD_DETAILS, foodId);
}

function getCategoryDetails(categoryId: string): DocumentReference {
  return doc(db, db_config.DB_TABLE_ALL_CATEGORIES, categoryId);
}

function getAllUserMenuCategories(resId: string): Query {
  return query(collection(db, db_config.DB_TABLE_USER_MENU_CATEGORIES), where('stadium_id', '==', resId), orderBy('order'));
}

function getUserMenuCategories(stadiumId: string): Query {
  return query(
    collection(db, db_config.DB_TABLE_USER_MENU_CATEGORIES),
    where('stadium_id', '==', stadiumId)
  );
}

function getUserMenuCategoryDetails(categoryId: string): DocumentReference {
  return doc(db, db_config.DB_TABLE_USER_MENU_CATEGORIES, categoryId);
}

function getSourceLang(site: string): CollectionReference {
  return collection(db, db_config.DB_TABLE_MENY_TRANSLATION, site, 'translation');
}

export {
  getAllOrders,
  getCurrentSettings,
  getAllCatagories,
  getSourceLang,
  getFoodDetails,
  getAllFoods,
  getCategoryDetails,
  getStadiumConfig,
  getUserMenuCategories,
  getAllUserMenuCategories,
  getUserMenuCategoryDetails,
};
